"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
const mapbox_gl_1 = __importDefault(require("mapbox-gl"));
require("mapbox-gl/dist/mapbox-gl.css");
const mapbox_1 = require("./mapbox");
const common_1 = require("./common");
(0, jquery_1.default)(() => __awaiter(void 0, void 0, void 0, function* () {
    const locations_elem = (0, jquery_1.default)('#locations');
    let selected_location;
    const is_mgmt = () => (0, jquery_1.default)('#mgmt').length > 0;
    const markers = new Map();
    const clearMarkers = () => {
        markers.forEach(marker => marker.remove());
        markers.clear();
    };
    mapbox_gl_1.default.accessToken = common_1.mapbox_token;
    const employees = yield (0, mapbox_1.fetch_employees)();
    const map = new mapbox_gl_1.default.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: common_1.USACentered,
        zoom: 4
    });
    const change_location = (location) => __awaiter(void 0, void 0, void 0, function* () {
        selected_location = location;
        const salaried = (0, jquery_1.default)('#salaried').prop('checked');
        if (is_mgmt()) {
            clearMarkers();
            employees.filter(employee => {
                if (salaried && employee.status.toLowerCase().includes('salary')) {
                    return true;
                }
                else if (!salaried && employee.status.toLowerCase().includes('hourly')) {
                    return true;
                }
                return false;
            }).forEach(employee => {
                var _a, _b;
                const color = employee.status.toLowerCase()
                    .includes('hourly')
                    ? common_1.marker_colors.hourly
                    : common_1.marker_colors.salaried;
                if (employee.location) {
                    create_marker({
                        id: parseInt(employee.id) || 0,
                        lat: (_a = employee.location) === null || _a === void 0 ? void 0 : _a.location[1],
                        lng: (_b = employee.location) === null || _b === void 0 ? void 0 : _b.location[0],
                        name: `${employee.firstname} ${employee.lastname}<br/>${employee.status}`
                    }, color);
                }
            });
        }
        yield activate_isochrone(location.lat, location.lng, salaried ? 45 : 30);
    });
    common_1.locations
        .sort((a, b) => a.name.localeCompare(b.name))
        .forEach(location => {
        (0, jquery_1.default)('<button>')
            .addClass('btn btn-velocity mt-1')
            .text(location.name)
            .appendTo(locations_elem)
            .on('click', () => __awaiter(void 0, void 0, void 0, function* () {
            yield change_location(location);
        }));
    });
    (0, jquery_1.default)('#salaried, #hourly').on('click', () => __awaiter(void 0, void 0, void 0, function* () {
        if (selected_location) {
            yield change_location(selected_location);
        }
    }));
    const clear_isohrone_layers = () => map.getStyle().layers
        .filter(layer => layer.id.startsWith('isochrone-'))
        .forEach(layer => map.removeLayer(layer.id));
    const activate_isochrone = (lat_1, lng_1, ...args_1) => __awaiter(void 0, [lat_1, lng_1, ...args_1], void 0, function* (lat, lng, minutes = 45, contoursCount = 3, profile = 'driving') {
        var _a;
        clear_isohrone_layers();
        try {
            const { data, contours, labels } = yield (0, mapbox_1.fetch_isochrone_cached)(lat, lng, minutes, contoursCount, profile);
            // Update source data
            (_a = map.getSource('isochrones')) === null || _a === void 0 ? void 0 : _a.setData(data);
            for (let i = 0, idx = 1; i < labels.length; ++i, ++idx) {
                (0, jquery_1.default)(`#ct_${idx}`).text(labels[i]);
            }
            // Add layers for each contour (in reverse order to show smaller areas on top)
            for (let i = contours.length - 1; i >= 0; i--) {
                const minutes = contours[i];
                const layerId = `isochrone-${labels[i]}`;
                const colorIndex = Math.min(i, common_1.colors.length - 1);
                map.addLayer({
                    id: layerId,
                    type: 'fill',
                    source: 'isochrones',
                    layout: {},
                    paint: {
                        'fill-color': common_1.colors[colorIndex],
                        'fill-opacity': 0.5,
                        'fill-outline-color': '#000'
                    },
                    filter: ['==', ['get', 'contour'], minutes]
                });
            }
            map.flyTo({ center: [lng, lat], zoom: 9 });
            (0, jquery_1.default)('#legend').removeClass('d-none');
        }
        catch (error) {
            alert('Error generating isochrone. Please check your inputs and try again.');
        }
    });
    const create_marker = (location, color, do_not_track = false) => {
        const popup = new mapbox_gl_1.default.Popup({
            closeButton: false,
            closeOnClick: false,
            offset: 25
        }).setHTML(location.name);
        const marker = new mapbox_gl_1.default.Marker({ color })
            .setLngLat({ lat: location.lat, lng: location.lng })
            .addTo(map);
        if (!do_not_track) {
            markers.set(location.name, marker);
        }
        return (0, jquery_1.default)(marker.getElement())
            .attr('id', location.name)
            .on('click', () => __awaiter(void 0, void 0, void 0, function* () { return yield change_location(location); }))
            .on('mouseenter', () => popup.setLngLat(marker.getLngLat()).addTo(map))
            .on('mouseleave', () => popup.remove());
    };
    map.on('load', () => __awaiter(void 0, void 0, void 0, function* () {
        map.addSource('isochrones', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });
        common_1.locations.forEach(location => {
            create_marker(location, common_1.marker_colors.office, true);
        });
    }));
    const added_markers = new Set();
    let _user_added_id = 10000;
    (0, jquery_1.default)('#addAddress').on('click', () => __awaiter(void 0, void 0, void 0, function* () {
        const address_elem = (0, jquery_1.default)('#address');
        const address = address_elem.val().trim();
        if (!address) {
            return;
        }
        const addr_info = yield (0, mapbox_1.geocode_address)(address);
        if (!addr_info) {
            return window.alert('Could not find address, please try again.');
        }
        if (added_markers.has(addr_info.id)) {
            return;
        }
        added_markers.add(addr_info.id);
        create_marker({
            id: ++_user_added_id,
            lat: addr_info.location[1],
            lng: addr_info.location[0],
            name: address
        }, common_1.marker_colors.employee, true);
        address_elem.val('');
    }));
}));
